import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import img from '../Images/DistrictLogoColourCrop_small.jpg'

const useStyles = makeStyles({
  root: {
    backgroundColor: "white",
    paddingLeft: "1.5%",
    paddingTop: "0.3%",
  },
});

export default function Header() {
  const classes = useStyles();

  return (
            <>
            <Box className={classes.root}>
                <img src={img} />
            </Box>
            </>
  );
}